module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block main-block-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-articles bck-views"
  }, [_c('h2', {
    staticClass: "title"
  }, [_c('span', [_vm._v("挑選婚禮歌曲的重要原則")])]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('div', {
    staticClass: "row songpic-list"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box songpic-box"
  }, [_c('h5', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sort-no text-primary"
  }, [_vm._v("1.")]), _vm._v("\n                                    清楚了解挑選歌曲適用於婚禮的原因\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n                                    從歌詞含意和歌曲旋律，判斷這首歌為何適用於婚禮。\n                                    如：表達愛意、寄託承諾、期待幸福、祝福未來…….\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box songpic-box"
  }, [_c('h5', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sort-no text-primary"
  }, [_vm._v("2.")]), _vm._v("\n                                    充分掌握挑選歌曲適用於婚禮的時機\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n                                    求婚/迎賓、進場(一次、二次) 、愛情回顧影片、婚宴、送客/蜜月，各時機可能有不同的適用條件，根據歌詞、歌曲特色大致判斷適用性。\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box songpic-box"
  }, [_c('h5', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sort-no text-primary"
  }, [_vm._v("3.")]), _vm._v("\n                                    追求挑選歌曲的品質而不在於數目\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n                                    婚禮過程有各個不同的流程，因此對歌曲要表達的訊息和情緒有不同的要求，很多時候，好好挑選一首婚禮歌曲在適當的時機播放，比放很多首更令人難忘。\n                                  ")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("挑歌秘訣")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('ul', {
    staticClass: "songpic-imglist list-inline"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("婚曲歌詞")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("歌詞最能代表新人的心意，\n                                          "), _c('br'), _vm._v("寄予對方或告知親朋好友，\n                                          "), _c('br'), _vm._v("新人對婚姻的承諾與期待。")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("歌曲旋律")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("表達新人希望在婚禮時傳達的情緒，\n                                          "), _c('br'), _vm._v("緩慢的旋律能娓娓訴說深情，\n                                          "), _c('br'), _vm._v("而較快的旋律可以呈現歡樂的心情。")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-3.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("歌曲節奏")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("要考量適合的用法和時機，\n                                          "), _c('br'), _vm._v("和婚禮儀式或節目表演的畫面配合，\n                                          "), _c('br'), _vm._v("讓婚禮進行的每個階段都扣人心弦。")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("播放曲數")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("婚禮歌曲播放曲數有多種選擇，\n                                          "), _c('br'), _vm._v("適當搭配婚禮進行各階段，\n                                          "), _c('br'), _vm._v("完整呈現整個婚禮要傳達的美意。")])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a2f6bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SongsPick.vue
// module id = 167
// module chunks = 1